import { render, staticRenderFns } from "./ContactsAdd.vue?vue&type=template&id=70c1e04d&"
import script from "./ContactsAdd.vue?vue&type=script&lang=js&"
export * from "./ContactsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports